"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$indents = void 0;
const factory_1 = __importDefault(require("../factory"));
exports.$indents = factory_1.default
    .withName("indent")
    .sequence(s => s
    // eslint-disable-next-line no-irregular-whitespace
    .and(r => r.zeroOrMore(r => r.regExp(/^(?: {2}|　|\t)/)), "indentTexts")
    .action(({ indentTexts }) => {
    return {
        value: {
            indentTexts,
            indentDepth: indentTexts.length,
        },
        errors: [],
    };
}));
exports.default = exports.$indents;
//# sourceMappingURL=$indents.js.map